/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Box } from '@chakra-ui/react';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import _ from 'lodash';
import { useFormValidationToast } from '../../../services/actionToast';
import { useFetch } from '../../../hooks/useFetch';
import { TextAreaInputForm } from '../../inputs/forms/TextAreaInputForm';
import { FormActions, FormSection, FormShell } from '../../ui';

interface PoliticsFormProps {
  defaultValues?: any;
}

interface FormInputsProps {
  name: string;
  value: string;
  placeholder?: string;
  label: string;
  yup: any;
}

export default function PoliticsForm({ defaultValues = {} }: PoliticsFormProps) {
  const validationToast = useFormValidationToast();
  const baseUrl = '/v1/admin/globals';
  const { requestApi } = useFetch(baseUrl);
  const yupschema: any = {};
  const defaultValuesSchema: any = {};

  const formInputs: FormInputsProps[] = [
    {
      name: 'privacy_policy',
      value: defaultValues.privacy_policy ?? '',
      placeholder: '',
      label: 'Descrição',
      yup: Yup.string(),
    },
  ];

  formInputs.forEach((object) => {
    yupschema[object.name] = object.yup;
    defaultValuesSchema[object.name] = object.value;
  });
  const schema = Yup.object().shape(yupschema);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValuesSchema,
  });

  const privacyPolicy = formInputs.find((field) => field.name === 'privacy_policy');

  const onSubmit = async (values: any) => {
    const params = {
      ...defaultValues,
      ...values,
      logo: _,
    };
    await requestApi('put', params);
  };

  useEffect(() => {
    if (defaultValues.privacy_policy) {
      reset(defaultValuesSchema);
    }
  }, [defaultValues]);

  return (
    <FormShell
      title="Políticas de Privacidade"
      description="Texto exibido aos usuários na política de privacidade."
    >
      <Box
        as="form"
        noValidate
        onSubmit={handleSubmit(onSubmit, validationToast)}
        display="flex"
        flexDirection="column"
        gap="16px"
      >
        <FormSection title="Dados Básicos">
          <TextAreaInputForm
            name={privacyPolicy?.name}
            label={privacyPolicy?.label}
            placeholder={privacyPolicy?.placeholder}
            errors={errors}
            register={register}
          />
        </FormSection>

        <FormActions isLoading={isSubmitting} />
      </Box>
    </FormShell>
  );
}
